/*** IMPORTS FROM imports-loader ***/
var define = false;

const getCurrentScrollTop = () => {
    return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0
}

const resetLastScrollTop = () => {
    return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0
}

const assignScrollStatus = () => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0
    const scrolled = scrollTop > 10

    if (scrolled) {
        document.body.classList.add('scrolled')
    } else {
        document.body.classList.remove('scrolled')
    }
}

const assignScrollDirection = lastScrollTop => {
    if (lastScrollTop) {
        const currentScrollTop = getCurrentScrollTop()

        if (currentScrollTop > lastScrollTop && currentScrollTop > 10) {
            document.body.classList.remove('scrolling-up')
            document.body.classList.add('scrolling-down')
            return 'down'
        } else {
            if ((lastScrollTop - currentScrollTop) >= 200 || currentScrollTop === 0) {
                document.body.classList.remove('scrolling-down')
                document.body.classList.add('scrolling-up')
            }
            return 'up'
        }
    }
}

const loadSiteHeader = () => {
    let lastScrollTop = null

    assignScrollStatus()

    document.addEventListener('scroll', () => {
        assignScrollStatus()
        const direction = assignScrollDirection(lastScrollTop)

        if (direction === 'down') {
            lastScrollTop = resetLastScrollTop()
        } else {
            const currentScrollTop = getCurrentScrollTop()

            if (Math.abs(currentScrollTop - lastScrollTop) > 200) {
                lastScrollTop = resetLastScrollTop()
            }
        }
    })
}

export default loadSiteHeader




// WEBPACK FOOTER //
// ./js/siteHeader.js